<template>
  <div class="fixed-sidebar-left">
    <div class="slimScrollDiv" style="position: relative; overflow: hidden; width: auto; height: 100%;">
      <ul class="nav navbar-nav side-nav nicescroll-bar" style="overflow: hidden; width: auto; height: 100%;">
        <navigation-item v-for="(item, index) in menuItems" :key="index" :item="item" :index="index"
          :selectedIndex="selectedIndex" @selectItem="selectItem(index)" :isActive="index === selectedIndex" />
        <li style="text-align: center; position: absolute; right: 0; bottom: 0;">
          <span>Verzió: 1.0.0</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import GenericButton from '@/components/shared/buttons/GenericButton';
import NavigationSideBarItem from '@/components/shared/navigations/NavigationSideBarItem';

export default {
  name: 'NavigationSideBar',
  components: {
    'navigation-item': NavigationSideBarItem,
  },
  props: {},
  data() {
    return {
      mailToBody: {},
      selectedIndex: undefined,
      workerItems: [
        {
          path: '#/dashboard',
          localeKey: 'app.navigation.sidebar.menuItems.dashboard',
          iconClass: 'ti-home',
        },
        {
          path: '#/tasks',
          localeKey: 'app.navigation.sidebar.menuItems.tasks',
          iconClass: 'ti-calendar',
        },
        {
          path: '#/notes',
          localeKey: 'app.navigation.sidebar.menuItems.notes',
          iconClass: 'ti-comment',
        },
      ],
    };
  },
  created() {
    this.fetchCommonData(this.loggedInUser.partner_id).then((response) => {
      this.mailToBody = {
        name: this.loggedInUser.name,
        role: this.$t(`app.mailRoles.${this.loggedInUser.role}`),
        partner: response.partner.name,
      };
    });
    // this.vivuPartnerId = this.loggedInUser.partner_id;
  },
  computed: {
    ...mapGetters({
      loggedInUser: 'loggedInUser',
      commonData: 'partners/commonData',
    }),
    vivuPartnerId() {
      return this.loggedInUser.partner_id;
    },
    superAdminItems() {
      return [
        {
          path: '#/partners',
          localeKey: 'app.navigation.sidebar.menuItems.partners',
          iconClass: 'ti-user',
        },
      ];
    },
    vivuItems() {
      return [
        {
          path: '#/dashboard',
          localeKey: 'app.navigation.sidebar.menuItems.dashboard',
          iconClass: 'ti-home',
        },
        {
          path: '#/inspections',
          localeKey: 'app.navigation.sidebar.menuItems.inspections',
          iconClass: 'ti-notepad',
        },
        {
          path: '#/tasks',
          localeKey: 'app.navigation.sidebar.menuItems.tasks',
          iconClass: 'ti-calendar',
        },
        {
          path: '#/documents',
          localeKey: 'app.navigation.sidebar.menuItems.documents',
          iconClass: 'ti-files',
        },
        {
          path: '#/notes',
          localeKey: 'app.navigation.sidebar.menuItems.notes',
          iconClass: 'ti-comment',
        },
      ];
    },
    partnerAdminItems() {
      return [
        {
          path: '#/dashboard',
          localeKey: 'app.navigation.sidebar.menuItems.dashboard',
          iconClass: 'ti-home',
        },
        {
          path: '#/sites',
          localeKey: 'app.navigation.sidebar.menuItems.sites',
          iconClass: 'ti-location-pin',
        },
        {
          path: '#/criteria_categories',
          localeKey: 'app.navigation.sidebar.menuItems.statements',
          iconClass: 'ti-bar-chart',
        },
        {
          path: '#/base_states',
          localeKey: 'app.navigation.sidebar.menuItems.base_states',
          iconClass: 'ti-flag',
        },
        {
          path: '#/inspections',
          localeKey: 'app.navigation.sidebar.menuItems.inspections',
          iconClass: 'ti-notepad',
        },
        {
          path: '#/tasks',
          localeKey: 'app.navigation.sidebar.menuItems.tasks',
          iconClass: 'ti-calendar',
        },
        {
          path: '#/documents',
          localeKey: 'app.navigation.sidebar.menuItems.documents',
          iconClass: 'ti-files',
        },
      ];
    },
    adminItems() {
      return [
        {
          path: '#/dashboard',
          localeKey: 'app.navigation.sidebar.menuItems.dashboard',
          iconClass: 'ti-home',
        },
        {
          path: '#/sites',
          localeKey: 'app.navigation.sidebar.menuItems.sites',
          iconClass: 'ti-location-pin',
        },
        {
          path: '#/criteria_categories',
          localeKey: 'app.navigation.sidebar.menuItems.statements',
          iconClass: 'ti-bar-chart',
        },
        {
          path: '#/base_states',
          localeKey: 'app.navigation.sidebar.menuItems.base_states',
          iconClass: 'ti-flag',
        },
        {
          path: '#/inspections',
          localeKey: 'app.navigation.sidebar.menuItems.inspections',
          iconClass: 'ti-notepad',
        },
        {
          path: '#/tasks',
          localeKey: 'app.navigation.sidebar.menuItems.tasks',
          iconClass: 'ti-calendar',
        },
        {
          path: '#/documents',
          localeKey: 'app.navigation.sidebar.menuItems.documents',
          iconClass: 'ti-files',
        },
      ];
    },
    menuItems() {
      if (this.loggedInUser.role == 'admin') {
        return this.adminItems;
      } else if (this.loggedInUser.role == 'vivu') {
        return this.vivuItems;
      } else if (this.loggedInUser.role == 'worker') {
        return this.workerItems;
      } else if (this.loggedInUser.role == 'super_admin') {
        return this.superAdminItems;
      }
      return this.partnerAdminItems;
    },
  },
  methods: {
    ...mapActions({
      fetchUser: 'users/fetchUser',
      fetchNotifications: 'users/fetchNotifications',
      fetchCommonData: 'partners/fetchCommonData',
    }),
    selectItem(index) {
      this.$eventBus.hideLoading({});
      this.fetchUser({ id: this.loggedInUser.id }).then((response) => {
        this.$emit('hasNewFeed', response.new_feed_count);
      });
      this.fetchNotifications({ id: this.loggedInUser.id, pageIndex: 1 }).then((response) => {
        this.$emit('hasNewNotification', response.total_count);
      }),
        this.selectedIndex = index;
    },
  },
};
</script>

<style lang="scss">
.fixed-sidebar-left .side-nav>li>a:active {
  background: none;
  color: unset;
}

.fixed-sidebar-left .side-nav>li>a:focus {
  background: none;
  color: unset;
}

@media print {
  .fixed-sidebar-left {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/navigations/NavigationSidebar.vue